import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import IndexPage from '../views/IndexPage.vue'
import TabsPage from '../views/TabsPage.vue'


const routes: Array<RouteRecordRaw> = [
  {
    component: TabsPage,
    path: '/',
    children: [
      {
        path: '',
        name: 'Inicio',
        component: () => import('@/views/HomePage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/entidad/:entidad_id',
        name: 'Ficha de la entidad',
        component: () => import('@/views/EntidadPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },

  {
    path: '/login',
    component: () => import('@/views/LoginPage.vue')
  },
  /** Compatibilidad con enlaces antiguos a la portada */
  {
    path: '/organizacion/home',
    redirect: '/'
  },
  // Ruta independiente para ver tareas (desde notificaciones)
  {
    path: '/tareas/:task_id',
    name: 'TareaDetail',
    component: () => import('@/views/TaskDetailView.vue'),
    meta: { requiredAuth: true }
  },
  {
    path: '/organizacion/',
    component: TabsPage,
    children: [
      {
        path: 'Mensajes',
        name: 'Mis Mensajes',
        component: () => import('@/components/Mensaje/MensajeList.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'tasks/:user_id?',
        name: 'Tasks',
        props: route => ({
          userId: route.params.user_id ? Number(route.params.user_id) : null,
          type: 'notDone' // Tipo por defecto para mostrar tareas pendientes
        }),
        component: () => import('@/components/Task/TaskList.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'task/:task_id',
        name: 'TaskDetail',
        component: () => import('@/views/TaskDetailView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'procesos/:user_id?',
        name: 'Procesos',
        props: route => ({
          userId: route.params.user_id ? Number(route.params.user_id) : null,
        }),
        component: () => import('@/components/Proceso/ListComponent.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'proceso/:proceso_id',
        name: 'Proceso',
        component: () => import('@/components/Proceso/ItemComponent.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'Tiempos',
        name: 'Tiempos',
        component: () => import('@/components/Tiempo/TimesListView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'admin/tipos-acuerdo-economico',
        name: 'Administrar Tipos de Acuerdo',
        component: () => import('@/components/Admin/TipoAcuerdoAdminSimple.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'incidencias/:user_id?',
        name: 'Incidencias',
        props: route => ({
          userId: route.params.user_id ? Number(route.params.user_id) : null,
        }),
        component: () => import('@/views/IncidenciasPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'usuarios',
        name: 'Entidades',
        component: () => import('@/views/UsuariosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'inventario',
        name: 'Inventario',
        component: () => import('@/components/Organizacion/InventarioCrud.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/settings/',
    component: TabsPage,
    children: [
      {
        path: 'log',
        name: 'Log',
        component: () => import('@/components/Settings/LogList.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'config',
        component: () => import('@/views/Settings/ConfigPage.vue'),
        name: 'Configuración',
        meta: { requiredAuth: true }
      },
      {
        path: 'pendientes',
        name: 'Usuarios Pendientes',
        component: () => import('@/views/Settings/PendientesPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/informes',
    component: TabsPage,
    children: [
      {
        path: '',
        name: 'Informes periódicos',
        component: () => import('@/views/Informes/InformesListPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: ':id',
        name: 'Informe detalle',
        component: () => import('@/views/Informes/InformeDetailPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/financiero',
    component: TabsPage,
    children: [
      {
        path: '',
        name: 'financiero',
        component: () => import('@/views/FinancieroPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/facturas',
        name: 'Facturas',
        component: () => import('@/views/FacturasPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/tickets',
        name: 'Tickets',
        component: () => import('@/views/TicketsPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/tickets/pendientes',
        name: 'Tickets Pendientes',
        component: () => import('@/views/TicketsPendientesPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/presupuestos',
        name: 'Presupuestos',
        component: () => import('@/components/Financiero/PresupuestosCrud.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/proveedores',
        name: 'Proveedores',
        component: () => import('@/views/ProveedoresPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/transacciones',
        name: 'Transacciones',
        component: () => import('@/views/TransactionsPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/cecabank',
        name: 'Ceca Bank',
        component: () => import('@/views/CecaBankPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/productos',
        name: 'Productos (Tienda)',
        component: () => import('@/components/Financiero/ProductosCrud.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/saldos',
        name: 'Saldos',
        component: () => import('@/views/SaldosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/movimientos-bancarios',
        name: 'Movimientos Bancarios',
        component: () => import('@/views/MovimientosBancariosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/tickets',
        name: 'Tickets',
        component: () => import('@/views/TicketsPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/tickets/pendientes',
        name: 'Tickets Pendientes',
        component: () => import('@/views/TicketsPendientesPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/informes',
        name: 'Informes Financieros',
        component: () => import('@/views/Financiero/InformesView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/asientos',
        name: 'Asientos Contables',
        component: () => import('@/views/Financiero/AsientosView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/negocios',
        name: 'Negocios',
        component: () => import('@/components/Financiero/NegociosLineasCrud.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/comparativa-anual',
        name: 'Comparativa Anual',
        component: () => import('@/views/Financiero/ComparativaAnualView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/informe-economico-mensual',
        name: 'KPI Galidancia',
        component: () => import('@/views/Financiero/InformeEconomicoMensualView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/contratos',
        name: 'Contratos',
        component: () => import('@/views/ContratosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: '/financiero/contrato/:contrato_id',
        name: 'Contrato',
        component: () => import('@/views/ContratoDetailPage.vue'),
        meta: { requiredAuth: true }
      },

    ]
  },
  {
    path: '/clases',
    component: TabsPage,
    children: [
      {
        path: 'uploadVideo/:sesion_id',
        name: 'uploadVideo',
        component: () => import('@/views/Clase/UploadVideoPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/herramientas',
    component: TabsPage,
    children: [
      {
        path: '',
        name: 'Herramientas',
        component: () => import('@/views/HerramientasPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'importar-exfils-meta',
        name: 'Importar Exfils Meta',
        component: () => import('@/views/Herramientas/ImportarExfilsMetaPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/Tools/',
    component: IndexPage,
    children: [
      {
        path: 'CountAsistentes',
        name: 'CountAsistentes',
        component: () => import('@/components/Tools/CountAsistentes.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'Cart',
        name: 'Pagar actividad',
        component: () => import('@/views/Clase/CartPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'sesion/:sesion_id',
        name: 'Sesion de clase',
        component: () => import('@/views/Clase/SesionPage.vue'),
        meta: { requiredAuth: true }
      },
    ]
  },
  {
    path: '/galidancia/',
    component: TabsPage,
    children: [
      {
        path: 'sesiones',
        name: 'sesiones',
        component: () => import('@/components/Galidancia/CalendarSesiones.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'alquileres',
        name: 'Alquileres',
        component: () => import('@/views/Galidancia/AlquileresView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'alumnos',
        name: 'Alumnos Galidancia',
        component: () => import('@/views/Galidancia/AlumnosView.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'staff',
        name: 'Staff',
        component: () => import('@/components/Galidancia/StaffList.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'clases',
        name: 'clases',
        component: () => import('@/components/Galidancia/ClaseCrud.vue'),
        meta: { requiredAuth: true }
      },

      {
        path: 'clase/:clase_id',
        component: () => import('@/views/Clase/ClaseStat.vue'),
        name: 'Clase',
        meta: { requiredAuth: true }
      },
      {
        path: 'params',
        component: () => import('@/views/Galidancia/SettingsView.vue'),
        name: 'Parametros',
        meta: { requiredAuth: true }
      },
      {
        path: 'anuncios-app-alumnos',
        component: () => import('@/views/Galidancia/AnunciosAppAlumnosView.vue'),
        name: 'Anuncios App Alumnos',
        meta: { requiredAuth: true }
      },
      {
        path: 'calidad',
        component: () => import('@/views/Galidancia/CalidadView.vue'),
        name: 'Calidad Galidancia',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes',
        component: () => import('@/views/Galidancia/InformesView.vue'),
        name: 'Informes',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes/cenas',
        component: () => import('@/views/Galidancia/CenasReportView.vue'),
        name: 'Informe de Cenas',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes/pagos-alumno-mes',
        component: () => import('@/views/Galidancia/PagosAlumnoMesView.vue'),
        name: 'Pagos por Alumno y Mes',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes/asientos-sin-asignar',
        component: () => import('@/views/Galidancia/AsientosSinAsignarReportView.vue'),
        name: 'Asientos Sin Asignar',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes/entradas',
        component: () => import('@/views/Galidancia/EntradasReportView.vue'),
        name: 'Informe de Entradas',
        meta: { requiredAuth: true }
      },

      {
        path: 'informes/movimientos-sin-factura',
        component: () => import('@/views/Galidancia/MovimientosSinFacturaReportView.vue'),
        name: 'Movimientos sin Factura Asociada',
        meta: { requiredAuth: true }
      },

      {
        path: 'informes/asientos-por-actividades',
        component: () => import('@/views/Galidancia/AsientosPorActividadesReportView.vue'),
        name: 'Asientos por Actividades',
        meta: { requiredAuth: true }
      },
      {
        path: 'informes/carts',
        component: () => import('@/views/Galidancia/CartsInformeView.vue'),
        name: 'Carritos guardados',
        meta: { requiredAuth: true }
      },

    ],
  },

  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: 'mensajes',
        name: 'Mis mensajes',
        component: () => import('@/components/Mensaje/MensajeList.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'mensajes/chat/:partner_id',
        name: 'Chat mensajes',
        component: () => import('@/components/Mensaje/MensajeChat.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'user/:user_id',
        name: 'Usuario',
        component: () => import('@/components/User/UserItem.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'user/:user_id/acuerdo-economico',
        name: 'Acuerdo Económico',
        component: () => import('@/components/User/AcuerdoEconomico.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'asientos',
        name: 'Mis pagos',
        component: () => import('@/views/AsientosPage.vue'),
        meta: { requiredAuth: true }
      },
      {
        path: 'clases',
        component: () => import('@/views/ClasesPage.vue'),
        name: 'Mis clases',
        meta: { requiredAuth: true }
      },
      {
        path: 'asistencias/:clase_id?',
        component: () => import('@/views/Clase/AsistenciasPage.vue'),
        name: 'Mis asistencias',
        meta: { requiredAuth: true }
      },
      {
        path: 'confirmAsistencia/:sesion_id',
        component: () => import('@/components/Clase/confirmAsistencia.vue'),
        name: 'Confirmar asistencia',
        meta: { requiredAuth: true }
      },
      {
        path: 'home',
        component: () => import('@/views/HomePage.vue'),
        name: 'Galidancia',
        meta: { requiredAuth: true }
      },
      {
        path: 'galidancia',
        component: () => import('@/views/GalidanciaPage.vue'),
        name: 'Galidancia',
        meta: { requiredAuth: true }
      },
      {
        path: 'necesidades',
        component: () => import('@/views/Galidancia/NecesidadesView.vue'),
        name: 'Deteccion de Necesidades',
        meta: { requiredAuth: true }
      },
      {
        path: 'cuadromando',
        component: () => import('@/views/Galidancia/CuadroDeMando.vue'),
        name: 'cuadro de mando',
        meta: { requiredAuth: true }
      },
    ]
  },
  // Ruta independiente para validar entrada (sin menú)
  {
    path: '/validar-entrada',
    component: () => import('@/views/Galidancia/ValidarEntradaView.vue'),
    name: 'Validar Entrada',
    meta: { requiredAuth: true }
  },
  // Rutas cortas para tickets
  {
    path: '/tickets',
    redirect: '/financiero/tickets',
    meta: { requiredAuth: true }
  },
  {
    path: '/tickets/pendientes',
    redirect: '/financiero/tickets/pendientes',
    meta: { requiredAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
